import { z } from "zod";

import type { ModuleUsage } from "@skilitics/interact-online-analytics-query-endpoint-definitions/schemas";

export const UsageAnalyticsDateRange = z.object({
  startDate: z.date({ coerce: true }).optional(),
  endDate: z.date({ coerce: true }).optional(),
});

export type UsageAnalyticsDateRange = z.infer<typeof UsageAnalyticsDateRange>;

export type UsageAnalyticsQueryCriteria = {
  moduleVersion?: string;
} & UsageAnalyticsDateRange;

export type UsageAnalyticsQueryApi = {
  getModuleVersions: (moduleId: string) => Promise<string[]>;
  getModuleUsage: (moduleId: string, criteria?: UsageAnalyticsQueryCriteria) => Promise<ModuleUsage>;
};
